import React from 'react'
import { LinkContainer, NavigationContainer } from './styles'
import './index.css'
import { Helmet } from 'react-helmet'

const Navigation = (props) => (
  <NavigationContainer className='flex justify-between'>
    <LinkContainer>
    </LinkContainer>
    <Helmet title={'Lite FreshVoice'}/>
  </NavigationContainer>
)

export default Navigation



// WEBPACK FOOTER //
// src/layouts/LoggedOut/Navigation.js